import { defineMessages } from 'react-intl';

const messages = defineMessages({
  invalidUrlError: {
    id: 'premium-menu.basic-info.transferInfo.invalidUrl',
    defaultMessage: 'Enter a valid URL',
  },
  // Address
  applicationMailingAddress: {
    id: 'premium-menu.basic-info.address.applicationMailingAddress',
    defaultMessage: 'Application Mailing Address',
  },
  admissionsOffice: {
    id: 'premium-menu.basic-info.address.admissionsOffice',
    defaultMessage: 'Admissions Office',
  },
  financialAid: {
    id: 'premium-menu.basic-info.address.financialAid',
    defaultMessage: 'Financial Aid',
  },
  addressInvalidError: {
    id: 'premium-menu.basic-info.address.invalid',
    defaultMessage: 'Invalid value.',
  },
  country: {
    id: 'premium-menu.basic-info.address.country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'premium-menu.basic-info.address.state',
    defaultMessage: 'State',
  },
  city: {
    id: 'premium-menu.basic-info.address.city',
    defaultMessage: 'City',
  },
  zip: {
    id: 'premium-menu.basic-info.address.zip',
    defaultMessage: 'ZIP',
  },
  street: {
    id: 'premium-menu.basic-info.address.street',
    defaultMessage: 'Street Address',
  },
  email: {
    id: 'premium-menu.basic-info.address.email',
    defaultMessage: 'Email address',
  },
  fax: {
    id: 'premium-menu.basic-info.address.fax',
    defaultMessage: 'Fax number',
  },
  phone: {
    id: 'premium-menu.basic-info.address.phone',
    defaultMessage: 'Phone number',
  },
  tollFreePhone: {
    id: 'premium-menu.basic-info.address.tollFreePhone',
    defaultMessage: 'Toll-free number',
  },
  url: {
    id: 'premium-menu.basic-info.address.url',
    defaultMessage: 'URL',
  },

  // Contact
  namePrefix: {
    id: 'premium-menu.basic-info.contact.namePrefix',
    defaultMessage: 'Name Prefix',
  },
  firstName: {
    id: 'premium-menu.basic-info.contact.firstName',
    defaultMessage: 'First Name',
  },
  middleName: {
    id: 'premium-menu.basic-info.contact.middleName',
    defaultMessage: 'Middle Name',
  },
  lastName: {
    id: 'premium-menu.basic-info.contact.lastName',
    defaultMessage: 'Last Name',
  },
  jobTitle: {
    id: 'premium-menu.basic-info.contact.jobTitle',
    defaultMessage: 'Job Title',
  },
  jobDescription: {
    id: 'premium-menu.basic-info.contact.jobDescription',
    defaultMessage: 'Job Description',
  },
  studentFacultyRatioInvalidError: {
    id: 'premium-menu.basic-info.studentFacultyRatio.invalid',
    defaultMessage: 'Invalid value.',
  },

  websitePlaceholder: {
    id: 'premium-menu.basic-info.transferInfo.websitePlaceholder',
    defaultMessage: 'Example: http://www.yourcollege.edu/transfer',
  },
  transferWebsiteLabel: {
    id: 'premium-menu.basic-info.transferInfo.transferWebsiteLabel',
    defaultMessage:
      "Link to your institution's website section designated for transfer student admissions.",
  },
  transferSupportWebsiteLabel: {
    id: 'premium-menu.basic-info.transferInfo.transferSupportWebsiteLabel',
    defaultMessage:
      'Link to a list of support services that are available for transfer students at your institution.',
  },
  transferFinancialAidInfoWebsite: {
    id: 'premium-menu.basic-info.transferInfo.financialAidInfoWebsite',
    defaultMessage: 'Example: http://www.yourcollege.edu/fin-aid',
  },
  creditTransferInfoWebsiteLabel: {
    id: 'premium-menu.basic-info.transferInfo.creditTransferInfoWebsiteLabel',
    defaultMessage:
      'Link to credit transfer information that is available for transfer students at your institution.',
  },
  creditTransferInfoWebsitePlaceholder: {
    id:
      'premium-menu.basic-info.transferInfo.creditTransferInfoWebsitePlaceholder',
    defaultMessage: 'Example: http://www.yourcollege.edu/credit-transfer',
  },

  // Academic Residency
  academicResidencyLabel: {
    id: 'premium-menu.basic-info.transferInfo.academicResidencyLabel',
    defaultMessage:
      'Minimum credit hours that a transfer student must complete through the institution in order to graduate.',
  },

  // Credit Cap
  creditCapLabel: {
    id: 'premium-menu.basic-info.transferInfo.creditCapLabel',
    defaultMessage:
      'The maximum number of credits that a student can transfer to your institution.',
  },

  // Credits Not Accepted
  transferCreditsNotAcceptedHint: {
    id: 'premium-menu.basic-info.menu-item.transferCreditsNotAcceptedHint',
    defaultMessage: 'Comma Separated List',
  },

  // Articulation Agreements
  articulationAgreementSystemsIntro: {
    id: 'premium-menu.basic-info.transferInfo.articulationAgreementSystemsIntro',
    defaultMessage:
      'Choose the state(s) in which you participate in system-wide articulation agreements. If the state you’re looking for isn’t listed here, please check back soon.',
  },

  articulationAgreementCollegesIntro: {
    id: 'premium-menu.basic-info.transferInfo.articulationAgreementCollegesIntro',
    defaultMessage:
      'Individual institutions your college has articulation agreements with',
  },

  articulationAgreementCollegesPlaceholder: {
    id: 'premium-menu.basic-info.transferInfo.articulationAgreementCollegesPlaceholder',
    defaultMessage: 'Search for a college...',
  },

  collegeSearchResults: {
    id: 'premium-menu.basic-info.transferInfo.collegeSearchResults',
    defaultMessage:
      'Search for "{keyword}", {results} results',
  },

  // Dual Admissions Programs
  dualAdmissionsProgramsIntro: {
    id: 'premium-menu.basic-info.transferInfo.dualAdmissionsProgramsIntro',
    defaultMessage: 'Institutions with which the college/university has dual admission programs',
  },
  dualAdmissionsProgramsPlaceholder: {
    id: 'premium-menu.basic-info.transferInfo.dualAdmissionsProgramsPlaceholder',
    defaultMessage: 'Search for institutions...',
  },

  // College Systems
  collegeSystemsIntro: {
    id: 'premium-menu.basic-info.transferInfo.collegeSystemsIntro',
    defaultMessage: 'Choose the college systems your institution is a part of',
  },
  collegeSystemsPlaceholder: {
    id: 'premium-menu.basic-info.transferInfo.collegeSystemsPlaceholder',
    defaultMessage: 'Choose a college system...',
  },
  collegeSystemsNoResults: {
    id: 'premium-menu.basic-info.transferInfo.collegeSystemsNoResults',
    defaultMessage: 'College system not found. We’re still adding systems, check back soon.',
  },

  // Transfer Application Requirements
  applicationRequirementsAddItemLabel: {
    id: 'premium-menu.basic-info.transferInfo.applicationRequirementsAddItemLabel',
    defaultMessage: 'Add Another Requirement',
  },
  applicationRequirementsRemoveItem: {
    id: 'premium-menu.basic-info.transferInfo.applicationRequirementsRemoveItem',
    defaultMessage: 'Remove Requirement',
  },
  applicationRequirementsOther: {
    id: 'premium-menu.basic-info.transferInfo.applicationRequirementsOther',
    defaultMessage: 'Other (Specify)',
  },

  // Transfer Credit Policies
  creditPoliciesOther: {
    id: 'premium-menu.basic-info.transferInfo.creditPoliciesOther',
    defaultMessage: 'Other (Specify)',
  },

  creditPoliciesSelectNonStatePolicies: {
    id: 'premium-menu.basic-info.transferInfo.creditPoliciesSelectNonStatePolicies',
    defaultMessage: 'Select all that apply',
  },

  creditPoliciesSelectStatePolicies: {
    id: 'premium-menu.basic-info.transferInfo.creditPoliciesSelectStatePolicies',
    defaultMessage: 'Choose states that you may have state specific policies in',
  },

  creditPoliciesNoStatePolicies: {
    id: 'premium-menu.basic-info.transferInfo.creditPoliciesNoStatePolicies',
    defaultMessage: 'Please check back as we continue to add state-specific transfer policies to select from.',
  },

  // Scholarship Availability
  scholarshipAvailabilityLabel: {
    id: 'premium-menu.basic-info.transferInfo.scholarshipAvailabilityLabel',
    defaultMessage: 'Are scholarships available for transfer students?',
  },
});

export default messages;
